import { gql } from 'apollo-angular';

export const CONTACT_PERSON_BASE_FRAGMENT = gql`
  fragment ContactPersonBaseFragment on ContactPerson {
    id
    salutation
    firstName
    lastName
    email
    phone
  }
`;
